import { useState } from "react";
import React from "react";
import "../css/components/InputFecha.css";
import InputMask from "react-input-mask";
import Disclaimer from "./Disclaimer";
import { autoScrollByElemento } from "./Utilitario";

function InputFecha(props) {
  const {
    id,
    inputmode = "tel",
    disabled,
    label,
    value,
    onBlur,
    onChange,
    onClickProp,
    disablePaste,
    error,
    name,
    mensajeDisclaimer,
    typeInput = "text",
    placeholder,
    dataError,
    readonly,
    required,
  } = props;
  const [stateHolder, setStateholder] = useState(placeholder);
  const [inElemento, setInElemento] = useState(false);

  function eventOnBlur(event) {
    if (onBlur) {
      onBlur(event);
    }
    setStateholder(" ");
    setInElemento(false);
  }

  function eventOnChange(event) {
    setInElemento(true);
    onChange(event);
  }

  function handlerCopy(e) {
    if (disablePaste === true) {
      e.preventDefault();
    }
  }

  function onClick(event) {
    autoScrollByElemento(event);
    if (typeInput === "date") {
      setStateholder("DD/MM/AAAA");
    }
    if (onClickProp) {
      onClickProp(event);
    }
  }

  function isDone() {
    return value !== "" && !error && !inElemento;
  }

  let className = ["bbva-input bg-color"];
  if (disabled) {
    className = [...className, "input--disabled"];
  } else if (error) {
    className = [...className, "input--error"];
  } else if (isDone()) {
    className = [...className, "input--success"];
  }

  const inputProps = {
    id: id,
    name: name,
    placeholder: stateHolder ? stateHolder : " ",
    className: className.join(" "),
    onPaste: handlerCopy,
    onCopy: handlerCopy,
    inputMode: inputmode,
    onChange: eventOnChange,
    onBlur: eventOnBlur,
    onClick: onClick,
    value: value,
    disabled: disabled,
    readOnly: readonly,
    required: required,
    autoComplete: "off",
    type: "text",
    "data-error": dataError,
  };

  return (
    <div className="input-container-input input__wrapper  textfield-cuentas__div-item">
      <InputMask mask={value !== "" ? "99/99/9999" : ""} {...inputProps} />
      <label htmlFor={id} className="bbva-input-label">
        {label}
      </label>
      <Disclaimer
        className="disclamer"
        mensaje={mensajeDisclaimer && error === "" ? mensajeDisclaimer : error}
        error={error !== ""}
      />
    </div>
  );
}

export default InputFecha;



// WEBPACK FOOTER //
// ./src/components/InputFecha.js